import React from 'react';
import ProfilePage from '../Components/ProfilePage';
import './Profile.css';
import AppointmentsList from '../Appointments/AppointmentsList';
import CommonTabs from '../Components/CommonTab';

const moment = require('moment-timezone');

class ProfileTabs extends React.Component {
    constructor(props) {
        super(props);
        //console.log(props)
        //console.log(props.exhibitor);
        var enableAppointments = 'N';
        if (global.$profile.appointments == null) {
            enableAppointments = "N";
        }
        else {
            enableAppointments = global.$profile.appointments.enable;
        }

        this.state = {
            code: global.$code,
            s3: global.$s3,
            bucket: global.$s3bucket,
            enableappointments: enableAppointments
        };
    }

    render() {

        const tabs = [
            { key: 'profile', title: 'My Profile', content: <ProfilePage /> },
        ];

        if (this.state.enableappointments.includes("Y")) {
            tabs.push({
                key: 'appointments',
                title: 'My Appointments',
                content: <AppointmentsList />
            });
        }

        return (
            <div className="profile-tabs">
                <CommonTabs tabs={tabs} />
            </div>

        );
    }
}
export default ProfileTabs;


